import {
  LOCALE_TO_MANUS_THEME_LANG,
  isAppLocale,
  type AppLocale,
} from '@/constants/appLocale'

/** Manus 主题类目 H5 基座（首页 11 类度假主题 iframe） */
export const MANUS_THEME_ORIGIN =
  'https://purplenavi-h9f4brfo.manus.space' as const

export const MANUS_THEME_SLUGS = [
  'onsen',
  'food',
  'shopping',
  'attractions',
  'hotels',
  'culture',
  'family',
  'couples',
  'skiing',
  'camping',
  'beach',
] as const

export type ManusThemeSlug = (typeof MANUS_THEME_SLUGS)[number]

export function isManusThemeSlug(s: string): s is ManusThemeSlug {
  return (MANUS_THEME_SLUGS as readonly string[]).includes(s)
}

/** 构建主题页完整 URL，附带 ?lang=（与 Manus 侧约定一致） */
export function buildManusThemeUrl(slug: ManusThemeSlug, i18nLanguage: string): string {
  const lang: string = isAppLocale(i18nLanguage)
    ? LOCALE_TO_MANUS_THEME_LANG[i18nLanguage as AppLocale]
    : 'zh-CN'
  return `${MANUS_THEME_ORIGIN}/${slug}?lang=${encodeURIComponent(lang)}`
}
